(function() {
  'use strict';

  var config = window.HealingLabProteinbarPack;

  if (!config || !config.variants) {
    return;
  }

  var variantIds = Object.keys(config.variants);
  var productId = String(config.productId);
  var cartAddPattern = /\/cart\/add(?:\.js)?(?:\?|$)/;

  function formatLabel(template, values) {
    return Object.keys(values).reduce(function(label, key) {
      return label.split('[' + key + ']').join(String(values[key]));
    }, template || '');
  }

  function getVariantIdFromForm(form) {
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : '';
  }

  function isPackVariant(variantId) {
    return Object.prototype.hasOwnProperty.call(config.variants, String(variantId));
  }

  function isPackForm(form) {
    if (!form) {
      return false;
    }

    if (isPackVariant(getVariantIdFromForm(form))) {
      return true;
    }

    if (String(form.getAttribute('data-product-id') || '') === productId) {
      return true;
    }

    if (String(form.getAttribute('data-productid') || '') === productId) {
      return true;
    }

    var productContainer = form.closest('[data-product-id], [data-productid]');

    if (!productContainer) {
      return false;
    }

    return String(productContainer.getAttribute('data-product-id') || productContainer.getAttribute('data-productid') || '') === productId;
  }

  function getBuilderUrl(variantId, sourceUrl) {
    var target = new URL(config.url, window.location.origin);
    var source = sourceUrl ? new URL(sourceUrl, window.location.origin) : null;

    if (source) {
      source.searchParams.forEach(function(value, key) {
        if (key !== 'view' && key !== 'variant') {
          target.searchParams.set(key, value);
        }
      });
    }

    var previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');

    target.searchParams.set('view', 'proteinbar-pack');

    if (previewThemeId) {
      target.searchParams.set('preview_theme_id', previewThemeId);
    }

    if (variantId && isPackVariant(variantId)) {
      target.searchParams.set('variant', String(variantId));
    }

    return target.toString();
  }

  function isProteinbarProductUrl(href) {
    try {
      var url = new URL(href, window.location.origin);
      return url.origin === window.location.origin && url.pathname.indexOf('/products/' + config.handle) !== -1;
    } catch (error) {
      return false;
    }
  }

  function showBuilderError(builder) {
    if (builder && builder.__proteinbarPackBuilder) {
      builder.__proteinbarPackBuilder.showError();
    }
  }

  function routeToBuilder(variantId) {
    var builder = document.querySelector('[data-proteinbar-pack-builder]');

    if (builder) {
      showBuilderError(builder);
      return;
    }

    window.location.assign(getBuilderUrl(variantId));
  }

  function suppressLegacyOptions(form) {
    if (!form) {
      return;
    }

    form.querySelectorAll('gpo-container, gpo-hidden-inputs').forEach(function(container) {
      container.hidden = true;
      container.setAttribute('aria-hidden', 'true');
      container.style.setProperty('display', 'none', 'important');
      container.querySelectorAll('input, select, textarea, button').forEach(function(control) {
        control.disabled = true;
      });
    });
  }

  function appendCartDetail(list, label, value, className) {
    var item = document.createElement('li');

    item.className = 'product-details__item ' + className;

    if (label) {
      var labelElement = document.createElement('span');

      labelElement.className = 'product-details__property-label';
      labelElement.textContent = label + ': ';
      item.appendChild(labelElement);
    }

    item.appendChild(document.createTextNode(String(value)));
    list.appendChild(item);
  }

  function showCartPopup(item, quantity, itemCount) {
    var wrapper = document.querySelector('[data-cart-popup-wrapper]');
    var popup = document.querySelector('[data-cart-popup]');
    var title = document.querySelector('[data-cart-popup-title]');
    var quantityElement = document.querySelector('[data-cart-popup-quantity]');
    var quantityLabel = document.querySelector('[data-cart-popup-quantity-label]');
    var details = document.querySelector('[data-cart-popup-product-details]');

    if (!wrapper || !popup || !title || !quantityElement || !details) {
      window.location.assign('/cart');
      return;
    }

    title.textContent = item.product_title || item.title || '';
    quantityElement.textContent = quantity;

    if (quantityLabel) {
      quantityLabel.textContent = 'Cantidad: ' + quantity;
    }

    details.innerHTML = '';

    if (Array.isArray(item.options_with_values) && !item.product_has_only_default_variant) {
      item.options_with_values.forEach(function(option) {
        appendCartDetail(details, option.name, option.value, 'product-details__item--variant-option');
      });
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      appendCartDetail(details, '', item.variant_title, 'product-details__item--variant-option');
    }

    Object.keys(item.properties || {}).forEach(function(name) {
      var value = item.properties[name];

      if (name.charAt(0) !== '_' && String(value).length) {
        appendCartDetail(details, name, value, 'product-details__item--property');
      }
    });

    details.hidden = !details.children.length;

    var imageUrl = item.featured_image && (item.featured_image.url || item.featured_image);
    var imageWrapper = document.querySelector('[data-cart-popup-image-wrapper]');

    if (imageUrl && imageWrapper) {
      var previousImage = imageWrapper.querySelector('[data-cart-popup-image]');
      var image = document.createElement('img');

      if (previousImage) {
        previousImage.remove();
      }

      image.src = imageUrl;
      image.alt = item.product_title || item.title || '';
      image.className = 'cart-popup-item__image';
      image.setAttribute('data-cart-popup-image', '');
      imageWrapper.classList.remove('hide');
      imageWrapper.appendChild(image);
    }

    if (itemCount !== null) {
      document.querySelectorAll('[data-cart-popup-cart-quantity], [data-cart-count]').forEach(function(element) {
        element.textContent = itemCount;
      });

      document.querySelectorAll('[data-cart-count-bubble]').forEach(function(bubble) {
        bubble.classList.toggle('hide', itemCount === 0);
        bubble.classList.remove('critical-hidden');
      });
    }

    if (!wrapper.__proteinbarPackCloseBound) {
      wrapper.querySelectorAll('[data-cart-popup-close], [data-cart-popup-dismiss]').forEach(function(button) {
        button.addEventListener('click', function() {
          wrapper.classList.add('cart-popup-wrapper--hidden');
        });
      });

      wrapper.addEventListener('keyup', function(event) {
        if (event.key === 'Escape') {
          wrapper.classList.add('cart-popup-wrapper--hidden');
        }
      });

      wrapper.__proteinbarPackCloseBound = true;
    }

    wrapper.classList.remove('cart-popup-wrapper--hidden');
    wrapper.setAttribute('aria-hidden', 'false');
    popup.focus();
  }

  function setBuilderLoading(controller, isLoading) {
    controller.root.toggleAttribute('data-submitting', isLoading);
    controller.addButton.toggleAttribute('aria-busy', isLoading);

    if (isLoading) {
      controller.addButton.disabled = true;
    } else {
      controller.update();
    }
  }

  function addValidPackToCart(form, builder) {
    var controller = builder && builder.__proteinbarPackBuilder;

    if (!controller || builder.hasAttribute('data-submitting') || !nativeFetch) {
      return;
    }

    var formData = new FormData(form);
    var quantity = Number(formData.get('quantity')) || 1;

    formData.set('id', controller.variantId);
    formData.set('properties[Dark Chocolate por pack]', String(controller.counts.chocolate));
    formData.set('properties[Caramel Crunch por pack]', String(controller.counts.arequipe));
    setBuilderLoading(controller, true);

    nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData,
      credentials: 'same-origin'
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) {
            throw new Error(data.description || config.labels.cartError);
          }

          return data;
        });
      })
      .then(function(item) {
        return nativeFetch('/cart.js', {
          credentials: 'same-origin'
        })
          .then(function(response) {
            return response.ok ? response.json() : null;
          })
          .catch(function() {
            return null;
          })
          .then(function(cart) {
            showCartPopup(item, quantity, cart ? cart.item_count : null);
          });
      })
      .catch(function(error) {
        controller.error.textContent = error.message || config.labels.cartError;
        controller.error.hidden = false;
      })
      .then(function() {
        setBuilderLoading(controller, false);
      });
  }

  function requestLineFromParams(params) {
    var properties = {};

    params.forEach(function(value, key) {
      var match = key.match(/^properties\[(.+)\]$/);

      if (match) {
        properties[match[1]] = value;
      }
    });

    return {
      id: params.get('id'),
      properties: properties
    };
  }

  function requestLinesFromBody(body) {
    if (!body) {
      return [];
    }

    if (window.FormData && body instanceof FormData) {
      return [requestLineFromParams(body)];
    }

    if (window.URLSearchParams && body instanceof URLSearchParams) {
      return [requestLineFromParams(body)];
    }

    if (typeof body !== 'string') {
      return [];
    }

    var trimmedBody = body.trim();

    if (!trimmedBody) {
      return [];
    }

    if (trimmedBody.charAt(0) !== '{' && trimmedBody.charAt(0) !== '[') {
      return [requestLineFromParams(new URLSearchParams(trimmedBody))];
    }

    try {
      var parsed = JSON.parse(trimmedBody);

      if (Array.isArray(parsed)) {
        return parsed;
      }

      if (Array.isArray(parsed.items)) {
        return parsed.items;
      }

      return [parsed];
    } catch (error) {
      return [];
    }
  }

  function isValidPackLine(line) {
    var variantId = String(line && (line.id || line.variant_id || line.variantId) || '');

    if (!isPackVariant(variantId)) {
      return true;
    }

    var properties = line.properties || {};
    var chocolate = Number(properties['Dark Chocolate por pack']);
    var arequipe = Number(properties['Caramel Crunch por pack']);
    var size = Number(config.variants[variantId].size);

    return Number.isInteger(chocolate) && chocolate >= 0 && Number.isInteger(arequipe) && arequipe >= 0 && chocolate + arequipe === size;
  }

  function invalidPackVariantFromBody(body) {
    var invalidLine = requestLinesFromBody(body).find(function(line) {
      var variantId = String(line && (line.id || line.variant_id || line.variantId) || '');
      return isPackVariant(variantId) && !isValidPackLine(line);
    });

    return invalidLine ? String(invalidLine.id || invalidLine.variant_id || invalidLine.variantId) : '';
  }

  function decorateProductLink(link) {
    var href = link.getAttribute('href');

    if (!href || !isProteinbarProductUrl(href)) {
      return;
    }

    link.href = getBuilderUrl(null, href);
  }

  function decoratePackForm(form) {
    if (!isPackForm(form) || form.querySelector('[data-proteinbar-pack-builder]')) {
      return;
    }

    form.setAttribute('data-proteinbar-pack-redirect', '');
    form.querySelectorAll('[data-add-to-cart], button[type="submit"], input[type="submit"], [data-pf-type*="ATC"], [data-pf-type*="AddToCart"]').forEach(function(control) {
      var text = control.querySelector && control.querySelector('[data-add-to-cart-text]');

      if (text) {
        text.textContent = config.labels.cta;
      } else if (control.tagName === 'INPUT') {
        control.value = config.labels.cta;
      } else {
        control.textContent = config.labels.cta;
      }

      control.setAttribute('aria-label', config.labels.cta);
    });
  }

  function collectElements(root, selector) {
    var elements = [];

    if (root.nodeType !== 1) {
      return elements;
    }

    if (root.matches(selector)) {
      elements.push(root);
    }

    return elements.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
  }

  function decorateNode(root) {
    collectElements(root, 'a[href]').forEach(decorateProductLink);
    collectElements(root, 'form[action*="/cart/add"]').forEach(decoratePackForm);
    collectElements(root, '[data-proteinbar-pack-builder]').forEach(initBuilder);
  }

  function ProteinbarPackBuilder(root) {
    this.root = root;
    this.form = root.closest('form[action*="/cart/add"]') || document.querySelector('[data-section-type="product"] form[data-product-form]');
    this.productContainer = this.form ? this.form.closest('[data-section-type="product"]') : null;
    this.variantSelect = this.form ? this.form.querySelector('[name="id"]') : null;
    this.nativeAddButton = this.form ? this.form.querySelector('[data-add-to-cart]') : null;
    this.addButton = null;
    this.addButtonText = null;
    this.status = root.querySelector('[data-pack-status]');
    this.progress = root.querySelector('[data-pack-progress]');
    this.error = root.querySelector('[data-pack-error]');
    this.counts = {
      chocolate: 0,
      arequipe: 0
    };
    this.variantId = '';
    this.size = 0;

    if (!this.form || !this.variantSelect || !this.nativeAddButton) {
      return;
    }

    var visibleVariantSelector = this.form.querySelector('.single-option-selector');
    var variantControls = visibleVariantSelector ? visibleVariantSelector.closest('.product-form__controls-group') : null;

    if (variantControls && variantControls.parentNode === this.form) {
      this.form.insertBefore(root, variantControls.nextSibling);
    } else if (!this.form.contains(root)) {
      this.nativeAddButton.parentNode.insertBefore(root, this.nativeAddButton);
    }

    this.addButton = document.createElement('button');
    this.addButtonText = document.createElement('span');
    this.addButton.type = 'button';
    this.addButton.className = 'btn btn--secondary-accent proteinbar-pack-submit';
    this.addButton.setAttribute('data-proteinbar-pack-submit', '');
    this.addButtonText.setAttribute('data-proteinbar-pack-submit-text', '');
    this.addButton.appendChild(this.addButtonText);
    this.nativeAddButton.parentNode.insertBefore(this.addButton, this.nativeAddButton);
    this.nativeAddButton.disabled = true;
    this.nativeAddButton.hidden = true;
    this.nativeAddButton.setAttribute('aria-hidden', 'true');
    this.nativeAddButton.style.setProperty('display', 'none', 'important');

    root.__proteinbarPackBuilder = this;
    this.bindEvents();
    this.syncVariant(true);
    suppressLegacyOptions(this.form);

    this.legacyObserver = new MutationObserver(function() {
      suppressLegacyOptions(this.form);
    }.bind(this));

    this.legacyObserver.observe(this.form, {
      childList: true,
      subtree: true
    });

    document.documentElement.classList.add('proteinbar-pack-ready');
  }

  ProteinbarPackBuilder.prototype.bindEvents = function() {
    this.root.addEventListener('click', function(event) {
      var increaseButton = event.target.closest('[data-pack-increase]');
      var decreaseButton = event.target.closest('[data-pack-decrease]');

      if (increaseButton) {
        this.adjust(increaseButton.getAttribute('data-pack-increase'), 1);
      }

      if (decreaseButton) {
        this.adjust(decreaseButton.getAttribute('data-pack-decrease'), -1);
      }
    }.bind(this));

    this.addButton.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.root.getAttribute('data-valid') === 'true') {
        addValidPackToCart(this.form, this.root);
      } else {
        this.showError();
      }
    }.bind(this));

    this.variantSelect.addEventListener('change', function() {
      window.setTimeout(function() {
        this.syncVariant(false);
      }.bind(this), 0);
    }.bind(this));

    if (this.productContainer) {
      this.productContainer.addEventListener('variantChange', function() {
        window.setTimeout(function() {
          this.syncVariant(false);
        }.bind(this), 0);
      }.bind(this));
    }
  };

  ProteinbarPackBuilder.prototype.syncVariant = function(isInitial) {
    var nextVariantId = String(this.variantSelect.value);
    var variant = config.variants[nextVariantId];

    if (!variant) {
      return;
    }

    if (!isInitial && this.variantId && this.variantId !== nextVariantId) {
      this.counts.chocolate = 0;
      this.counts.arequipe = 0;
    }

    this.variantId = nextVariantId;
    this.size = Number(variant.size);
    this.update();
  };

  ProteinbarPackBuilder.prototype.adjust = function(flavor, delta) {
    if (!Object.prototype.hasOwnProperty.call(this.counts, flavor)) {
      return;
    }

    var total = this.counts.chocolate + this.counts.arequipe;

    if (delta > 0 && total >= this.size) {
      return;
    }

    this.counts[flavor] = Math.max(0, this.counts[flavor] + delta);
    this.error.hidden = true;
    this.update();
  };

  ProteinbarPackBuilder.prototype.update = function() {
    var total = this.counts.chocolate + this.counts.arequipe;
    var remaining = Math.max(this.size - total, 0);
    var variant = config.variants[this.variantId];
    var isAvailable = !variant || variant.available !== false;
    var isValid = this.size > 0 && total === this.size;

    Object.keys(this.counts).forEach(function(flavor) {
      this.root.querySelector('[data-pack-count="' + flavor + '"]').textContent = this.counts[flavor];
      this.root.querySelector('[data-pack-property="' + flavor + '"]').value = this.counts[flavor];
      this.root.querySelector('[data-pack-decrease="' + flavor + '"]').disabled = this.counts[flavor] === 0;
      this.root.querySelector('[data-pack-increase="' + flavor + '"]').disabled = total >= this.size;
    }.bind(this));

    this.progress.style.width = Math.min(total / this.size * 100, 100) + '%';
    this.root.classList.toggle('is-complete', isValid);
    this.root.setAttribute('data-valid', isValid ? 'true' : 'false');

    if (isValid) {
      this.status.textContent = config.labels.complete;
    } else {
      this.status.textContent = formatLabel(config.labels.selected, {
        count: total,
        size: this.size
      }) + ' · ' + formatLabel(config.labels.remaining, {
        count: remaining
      });
    }

    this.addButton.disabled = !isValid || !isAvailable;

    if (this.addButton.disabled) {
      this.addButton.setAttribute('aria-disabled', 'true');
    } else {
      this.addButton.removeAttribute('aria-disabled');
    }

    var buttonLabel = !isAvailable ? config.labels.soldOut : isValid ? config.labels.addToCart : formatLabel(config.labels.chooseRemaining, {
      count: remaining
    });

    if (this.addButtonText) {
      this.addButtonText.textContent = buttonLabel;
    }

    this.addButton.setAttribute('aria-label', buttonLabel);
  };

  ProteinbarPackBuilder.prototype.showError = function() {
    this.error.textContent = formatLabel(config.labels.error, {
      size: this.size
    });
    this.error.hidden = false;

    var firstAvailableIncrease = this.root.querySelector('[data-pack-increase]:not(:disabled)');

    if (firstAvailableIncrease) {
      firstAvailableIncrease.focus();
    }
  };

  function initBuilder(root) {
    if (!root.__proteinbarPackBuilder) {
      new ProteinbarPackBuilder(root);
    }
  }

  window.addEventListener('submit', function(event) {
    var form = event.target;

    if (!form.matches('form[action*="/cart/add"]') || !isPackForm(form)) {
      return;
    }

    var builder = form.querySelector('[data-proteinbar-pack-builder]');

    if (!builder) {
      event.preventDefault();
      event.stopImmediatePropagation();
      routeToBuilder(getVariantIdFromForm(form));
      return;
    }

    if (builder.getAttribute('data-valid') !== 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      showBuilderError(builder);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    addValidPackToCart(form, builder);
  }, true);

  window.addEventListener('click', function(event) {
    if (event.target.closest('[data-proteinbar-pack-submit]')) {
      return;
    }

    var cartLink = event.target.closest('a[href*="/cart/add"]');

    if (cartLink) {
      var cartUrl = new URL(cartLink.href, window.location.origin);
      var cartVariantId = cartUrl.searchParams.get('id');

      if (isPackVariant(cartVariantId)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        routeToBuilder(cartVariantId);
        return;
      }
    }

    var form = event.target.closest('form[action*="/cart/add"]');
    var purchaseControl = event.target.closest('[data-add-to-cart], button[type="submit"], input[type="submit"], [data-pf-type*="ATC"], [data-pf-type*="AddToCart"], .shopify-payment-button__button');

    if (form && purchaseControl && isPackForm(form)) {
      var formBuilder = form.querySelector('[data-proteinbar-pack-builder]');

      if (!formBuilder) {
        event.preventDefault();
        event.stopImmediatePropagation();
        routeToBuilder(getVariantIdFromForm(form));
      } else {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (formBuilder.getAttribute('data-valid') === 'true') {
          addValidPackToCart(form, formBuilder);
        } else {
          showBuilderError(formBuilder);
        }
      }

      return;
    }

    if (event.target.closest('[data-proteinbar-pack-builder]')) {
      return;
    }

    var productControl = event.target.closest('[data-product-id], [data-productid], [data-variant-id], [data-variantid]');

    if (!productControl || !event.target.closest('button, [role="button"]')) {
      return;
    }

    var controlProductId = String(productControl.getAttribute('data-product-id') || productControl.getAttribute('data-productid') || '');
    var controlVariantId = String(productControl.getAttribute('data-variant-id') || productControl.getAttribute('data-variantid') || '');

    if (controlProductId === productId || isPackVariant(controlVariantId)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      routeToBuilder(controlVariantId);
    }
  }, true);

  var nativeSubmit = HTMLFormElement.prototype.submit;

  HTMLFormElement.prototype.submit = function() {
    if (isPackForm(this)) {
      var builder = this.querySelector('[data-proteinbar-pack-builder]');

      if (!builder) {
        routeToBuilder(getVariantIdFromForm(this));
        return;
      }

      if (builder.getAttribute('data-valid') !== 'true') {
        showBuilderError(builder);
        return;
      }

      addValidPackToCart(this, builder);
      return;
    }

    return nativeSubmit.apply(this, arguments);
  };

  if (window.fetch) {
    var nativeFetch = window.fetch;

    window.fetch = function(input, options) {
      var url = typeof input === 'string' ? input : input && input.url;
      var invalidVariantId = url && cartAddPattern.test(new URL(url, window.location.origin).pathname) ? invalidPackVariantFromBody(options && options.body) : '';

      if (invalidVariantId) {
        routeToBuilder(invalidVariantId);
        return Promise.reject(new Error(formatLabel(config.labels.error, {
          size: config.variants[invalidVariantId].size
        })));
      }

      return nativeFetch.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
      this.__proteinbarPackUrl = url;
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
      var url = this.__proteinbarPackUrl;
      var invalidVariantId = url && cartAddPattern.test(new URL(url, window.location.origin).pathname) ? invalidPackVariantFromBody(body) : '';

      if (invalidVariantId) {
        routeToBuilder(invalidVariantId);
        this.abort();
        return;
      }

      return nativeSend.apply(this, arguments);
    };
  }

  function initialize() {
    if (isProteinbarProductUrl(window.location.href) && !document.querySelector('[data-proteinbar-pack-builder]')) {
      var productForm = document.querySelector('form[action*="/cart/add"]');
      routeToBuilder(getVariantIdFromForm(productForm));
      return;
    }

    decorateNode(document.documentElement);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            decorateNode(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
